import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Textarea, Select, Radio } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row, Hidden } from '../../../../../v2SPRINTA/atoms/Grid'

import SprintaTips from '../../../../../SPRINTA/molecules/SprintaTips'
import RadioBox from '../../../../../SPRINTA/molecules/RadioBox'

import { saveExperience } from '../../_utils'


import css from './style.module.css'
class HowWillItBe extends Component {

    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        const form = {}
        form[name] = this.props.data.experience[name]

        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        description: () => {
            if(!this.props.data.experience.description) {
                let error = "Informe uma descrição"
                this.description.setError(error)

                return {
                    element: this.description.refs.textarea,
                    error
                }
            }
            return false
        },
        intensity: () => {
            if(!this.props.data.experience.intensity) {
                let error = "Informe a intensidade"
                // this.description.setError(error)
                return {
                    element: this.intensity.refs.div,
                    error
                }
            }
            return false
        },
        // minAge: () => {
        //     if(!this.props.data.experience.minAge) {
        //         let error = "Informe a idade mínima"
        //         this.minAge.setError(error)
        //         return {
        //             element: this.minAge.refs.select,
        //             error
        //         }
        //     }
        //     return false
        // },
        duration: () => {
            if(!this.props.data.experience.duration) {
                let error = "Informe a duração"
                this.duration.setError(error)
                return {
                    element: this.duration.refs.select,
                    error
                }
            }
            return false
        },
        placeType: () => {
            if(!this.props.data.experience.placeType) {
                let error = "Informe o tipo do lugar"
                // this.placeType.setError(error)
                return {
                    element: this.placeType.refs.div,
                    error
                }
            }
            return false
        },
        doWhat: () => {
            if(!this.props.data.experience.doWhat) {
                let error = "Informe o que será feito"
                this.doWhat.setError(error)
                return {
                    element: this.doWhat.refs.textarea,
                    error
                }
            }
            return false
        },
    }

    inStep() {
        let { description, intensity, minAge, duration, placeType, doWhat } = this.props.data.experience
        return description || intensity || minAge || duration || placeType || doWhat ? true  : false
    }

    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    render() {
        let data = this.props.data
        return (
            <ContentInfo
                title='Como será sua experiência?'
                description='Descreva sua experiência para nós, informe a intensidade (dificuldade de ser realizada), tempo de duração e outros detalhes fundamentais para que os atletas decidam se irão realizar ou não sua experiência.'
                steps={this.props.steps}>
                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Detalhe a experiência que você planeja oferecer
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <SprintaTips>
                                A descrição da sua experiência é uma oportunidade de inspirar os atletas participarem da sua experiência. Especifique o que o pessoal irá fazer durante sua experiência, assim como itinerário e procure oferecer algo especial, marcante.. algo que ninguém conseguiria fazer sem sua ajuda.
                            </SprintaTips>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Textarea
                                label='Conte para nós como será a sua experiência'
                                maxLength={600}
                                ref={ref => this.description = ref}
                                name="description"
                                maxLengthString="Você digitou {lenght} de {limit} caracteres"
                                value={data.experience.description || ''}
                                onChange={e => this.handleChange(e.target)}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Qual será a intensidade da sua experiência
                            </Display>
                        </FormGroup>
                        <FormGroup ref={ref => this.intensity = ref}>
                            <Row>
                                <Col size='12 12 4'>
                                    <label style={{ cursor: 'pointer' }}>
                                        <Row>
                                            <Col size='12' hidden='xs sm'>
                                                <hr className={css.radioLine} />
                                            </Col>

                                            <Col size='1 1 12'>
                                                <Hidden sizes='md lg xl'>
                                                    <hr className={css.radioLineV} />
                                                </Hidden>
                                                <Radio
                                                    onChange={e => this.handleChange(e.target)}
                                                    name='intensity'
                                                    value={1}
                                                    checked={parseInt(data.experience.intensity, 10) === 1} />
                                            </Col>
                                            <Col size='11 11 12' className={css.radioContent}>
                                                <FormGroup>
                                                    <b>Pouca intensidade</b> <br />
                                                    Fácil e recomendada para qualquer idade ou preparo físico.
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </label>
                                </Col>
                                <Col size='12 12 4'>
                                    
                                    <label style={{ cursor: 'pointer' }}>
                                        <Row>
                                            <Col size='12' hidden='xs sm'>
                                                <hr className={css.radioLine} />
                                            </Col>

                                            <Col size='1 1 12'>
                                                <Hidden sizes='md lg xl'>
                                                    <hr className={css.radioLineV} />
                                                </Hidden>
                                                <Radio
                                                    onChange={e => this.handleChange(e.target)}
                                                    name='intensity'
                                                    value={2}
                                                    checked={parseInt(data.experience.intensity, 10) === 2} />
                                            </Col>
                                            <Col size='11 11 12' className={css.radioContent}>
                                                <div className={css.radioContent}>
                                                    <FormGroup>
                                                        <b>Moderada intensidade</b> <br />
                                                        Requer um preparo físico mínimo e idade mínima de 18 anos.
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                        </Row>
                                    </label>
                                </Col>
                                <Col size='12 12 4'>
                                    <label style={{ cursor: 'pointer' }}>
                                        <Row>
                                            <Col size='1 1 12'>
                                                <Radio
                                                    onChange={e => this.handleChange(e.target)}
                                                    name='intensity'
                                                    value={3}
                                                    checked={parseInt(data.experience.intensity, 10) === 3} />
                                            </Col>
                                            <Col size='11 11 12' className={css.radioContent}>
                                                <div className={css.radioContent}>
                                                    <FormGroup>
                                                        <b>SUPER intensa</b> <br />
                                                        Requer um bom condicionamento físico e os limites dos participantes serão testados ao máximo.
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                        </Row>
                                    </label>
                                </Col>
                            </Row>
                        </FormGroup>

                    </Col>
                </Row>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Qual idade mínima e duração da sua experiência?
                            </Display>
                        </FormGroup>
                    </Col>
                    <Col size='12 12 6'>
                        <FormGroup>
                            <Select
                                name='minAge'
                                onChange={e => this.handleChange(e.target)}
                                label="Idade mínima"
                                ref={ref => this.minAge = ref}
                                value={data.experience.minAge || ''}
                            >
                                <option value="">Sem idade minima</option>
                                <option value="16">16 anos</option>
                                <option value="18">18 anos</option>
                                <option value="25">25 anos</option>
                            </Select>
                        </FormGroup>
                    </Col>

                    <Col size='12 12 6'>
                        <FormGroup>
                            <Select
                                name='duration'
                                onChange={e => this.handleChange(e.target)}
                                label="Duração da experiência"
                                ref={ref => this.duration = ref}
                                value={data.experience.duration || ''}
                            >
                                <option value="">Selecione</option>
                                <option>Até 30 minutos</option>
                                <option>De 1 a 2 horas</option>
                                <option>Até 5 horas</option>
                                <option>Dia inteiro</option>
                            </Select>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12'>
                        <FormGroup
                                ref={ref => this.placeType = ref}
                            >
                            <Display size={3}>
                                Minha experiência será ao ar livre
                            </Display>
                            <br />
                            Minha experiência ocorrerá predominantemente ao ar livre (mais de 90%)
                        </FormGroup>
                    </Col>
                    <Col size='12 12 6'>
                        <FormGroup>
                            <RadioBox
                                icon='picture'
                                title='Outdoor'
                                text='Local ao ar livre'
                                name='placeType'
                                checked={data.experience.placeType === 'outdoor'}
                                value='outdoor'
                                onChange={e => this.handleChange(e.target)}                        
                                />
                        </FormGroup>
                    </Col>
                    <Col size='12 12 6'>
                        <FormGroup>
                            <RadioBox
                                icon='marketplace'
                                title='Indoor'
                                text='Local fechado'
                                name='placeType'
                                checked={data.experience.placeType === 'indoor'}
                                value='indoor'
                                onChange={e => this.handleChange(e.target)}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                O que os participantes irão fazer na sua experiência?
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Textarea
                                label='O que faremos na sua experiência?'
                                maxLength={600}
                                name="doWhat"
                                ref={ref => this.doWhat = ref}
                                value={data.experience.doWhat || ''}
                                maxLengthString="Você digitou {lenght} de {limit} caracteres"
                                onChange={e => this.handleChange(e.target)}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>
                
            </ContentInfo>
        )
    }

}

export default HowWillItBe


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/HowWillItBe/index.js